
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {authorizeCertApi, dictApi, measuringStandardApi} from "@/api/organization";
    import {newInstrumentApi} from "@/api/instrument";
    import {rulesApi} from "@/api/rules";
    import baseUrl, {imageUrl} from "../../constants";
    import KeyboardInput from "@/components/KeyboardInput.vue"
    import ckeditor4 from "@/components/CkeditorComponent.vue";
    import tempSave from "@/components/TempSave.vue";
    import SelectMechanism from "@/components/SelectMechanism.vue";
    import UpdateInstrument from "@/components/UpdateInstrument.vue";
    import MeasuringRange from "@/components/MeasuringRange.vue";
    import {Param} from "@/js/ParamList";
    import TableShowRangeBody from "@/components/table-show-range-body.vue";
    import TableShowRangeHead from "@/components/table-show-range-head.vue";
    import InspectionArchives from "@/components/examine/InspectionArchives.vue";
    import TableShowRangeBodyEjian from "@/components/table-show-range-body-ejian.vue";
    import MeasuringRangeEjian from "@/components/MeasuringRangeEjian.vue";
    @Component({
        name: 'measuringDetail',
        components: {
          MeasuringRangeEjian,
          TableShowRangeBodyEjian,
            KeyboardInput, ckeditor4, tempSave, SelectMechanism, MeasuringRange, TableShowRangeHead,TableShowRangeBody, UpdateInstrument, InspectionArchives}
    })
    export default class Home extends Vue {
        // ========== 性能优化相关属性 ==========
        // 渲染控制key
        renderKey = 0;
        // span-method 缓存
        private spanMethodTwoCache: any = null;
        // 仪表列表显示限制
        maxInstrumentDisplayCount = 50;

        title = "计量标准信息";
        pageType = "0";  //0添加  1编辑  2查看
        manageStatus = 0; //0新建 1复查 2改造
        mode = 0; //
        id = "0";   //计量标准id
        checkMaxErrors = (rule: any, value: any, cb: any) => {
            if (value.length == 0) {
                cb(new Error('请输入最大允许误差!'));
            } else {
                let isBlank = false;
                value.forEach((v: any) => {
                    if (v.val === "") {
                        isBlank = true;
                    }
                });
                if (isBlank) {
                    cb(new Error('请输入最大允许误差!'));
                } else {
                    cb();
                }
            }
        }
        form = {
            /** 计量标准考核证书号*/
            certificateNo: '',
            /** 建标单位ID */
            ownerId: '',
            /** 建标单位Name ID*/
            companyNameId: '',
            /** 建标单位*/
            companyName: '',
            /** 计量标准代码 */
            code: '',
            /** 计量标准名称*/
            name: '',
            /** 测量范围*/
            surveyRanges: [],
            /** 不确定度/准确度等级/最大允许误差*/
            maxErrors: [],
            maxError: '',
            /** 保存地点*/
            storageLocation: '',
            /** 发证机关 名称ID */
            issuingAuthorityNameId: '', //manufactorNameId
            /** 发证机关*/
            issuingAuthority: '',
            /** 发证日期*/
            issuedDate: '',
            /** 有效期*/
            termValidity: '',
            /** 使用状态*/
            useStatus: '',
            /** 计量标准考核证书影印件*/
            enclosure: '',
            /** 变更证明文件 */
            changeFiles: '',
            /** 0:待提交 1:未审核 2:已生效 3:未通过 */
            status: 0,
          surveyRangesHtml: '',
          accuracyLevelHtml: '',
            /** 参数列表 包含 测量范围  和 不确定度等级 */
            paramList: [] as Param[],
            //管理状态 0正常 1复查 2改造 3初始 4重建
            manageStatus: {value: 0},
            isAuditPass: 0,
            /** 首次建标年份 */
            firstCreatedYear: "",
            /**被替换的计量标准ID */
            replaceId: '',
            rules: {
                certificateNo: [{required: true, message: '请输入计量标准考核证书号', trigger: 'blur'}],
                companyName: [{required: true, message: '请输入建标单位', trigger: 'blur'}],
                name: [{required: true, message: '请输入计量标准名称', trigger: 'blur'}],
                code: [{required: true, message: '请输入计量标准代码', trigger: 'blur'}],
                surveyRangesHtml: [{required: true, message: '请填写测量范围 和 不确定度等级', trigger: 'blur'}],
                maxErrors: [{required: true, validator: this.checkMaxErrors}],
                storageLocation: [{required: true, message: '请输入保存地点', trigger: 'blur'}],
                issuingAuthority: [{required: true, message: '请输入发证机关', trigger: 'change'}],
                issuedDate: [{required: true, message: '请选择发证日期', trigger: 'change'}],
                termValidity: [{required: true, message: '请选择有效期', trigger: 'change'}],
                useStatus: [{required: true, message: '请选择使用状态', trigger: 'change'}],
                enclosure: [{required: true, message: '请上传计量标准考核证书影印件', trigger: 'change'}],
                firstCreatedYear: [{required: true, message: '请选择首次建标年份', trigger: 'change'}],
            }
        }
        form2 = {
            //计量标准器 和 主要配套设备
            isDevicesNone: false,
            measuringDevices: [],
            instrumentList: [], //本单位计量器具
            instrumentListFilter: [], //过滤后需要展示出来的器具
            rules: {
                instrId: [{required: true, message: '请选择器具名称', trigger: 'change'}]
            }
        }
        form3 = {
            //开展的检定/校准项目
            measuringItems: [] as any,
            rules: {
                surveyRangesHtml: [{required: true, message: '请填写测量范围', type: 'change'}],
                projectId: [{required: true, message: '请选择项别名称', trigger: 'change'}],
                maxError: [{required: true, message: '请输入最大允许误差', trigger: 'blur'}],
                ruleId: [{required: true, message: '请选择规程规范', trigger: 'blur'}],
                lowerLimit: [{required: true, message: '请输入测量下限值', trigger: 'blur'}],
                lowerUnit: [{required: true, message: '请输入测量下限单位', trigger: 'blur'}],
                upperLimit: [{required: true, message: '请输入测量上限值', trigger: 'blur'}],
                upperUnit: [{required: true, message: '请输入测量上限单位', trigger: 'blur'}],
            }
        }
        updateInstr = {
            visible: false,
            instrId: -1,
            dataIndex: -1,
        }
        baseUrl = baseUrl
        headers = {Authorization: ""}
        fileList = [] as any;
        fileListV2 = [] as any;
        private closePage: any;
        dialogImageUrl = "";
        imagePreviewVisible = false;
        accept = ".png,.jpg,.pdf";
        limit = 10;
        listType = "picture-card"
        projectList = [] //项别列表
        props = {
            emitPath: false,
            value: 'instrumentNameId',
            label: 'name',
        }
        userData = null as any //当前登录用户
        measuringRulesFilterd = []
        loading = false
        showAllLevels = false;
        sysMeasuringUpdate = false;
        addSurveyRanges = {
            visible: false,
            surveyRanges: [],
            params: null as any,
        }
        addSurveyRangesEjian = {
          visible: false,
          surveyRanges: [],
          params: null as any,
        }
        review = {
            failText: '',
            failDialog: false,
        }
        fullScreen = false;
        firstYearIsNull = true;// 首次建标日期是否是空
        codeIsNull = true; //标准代码是否是空
        //追溯信息弹框
        reviewInfoDialog = {
            visible: false,
        }
        inspectionParams = {
            instrumentsId: 0,
            checkResult: 1,
            orderInstrId: 0,
            dataIndex: 0,
        };

        // ========== 计算属性 - 性能优化 ==========
        // 替代模板中的 filterDevices 方法调用
        get filteredDevices(): any[] {
            if(this.form2.isDevicesNone){
                return this.form2.measuringDevices.filter((d: any) => d.type == 0);
            }
            return this.form2.measuringDevices;
        }

        // measuringItems 数据引用
        get measuringItemsData(): any[] {
            return this.form3.measuringItems;
        }

        // 缓存的选择器选项列表 - 限制显示数量以优化性能
        get filteredInstrumentList(): any[] {
            const list = this.form2.instrumentListFilter;
            if (list.length <= this.maxInstrumentDisplayCount) {
                return list;
            }
            return list.slice(0, this.maxInstrumentDisplayCount);
        }

        // ========== 性能优化方法 ==========
        // 获取显示的仪表列表（限制数量，排除当前选中的）
        getDisplayInstruments(currentInstrId: string): any[] {
            const list = this.form2.instrumentListFilter;
            // 如果列表超过限制数量，只显示前50条（排除当前已选中的）
            if (list.length > this.maxInstrumentDisplayCount) {
                const filtered = list.filter((instr: any) => instr.id !== currentInstrId);
                return filtered.slice(0, this.maxInstrumentDisplayCount - 1);
            }
            return list.filter((instr: any) => instr.id !== currentInstrId);
        }

        // 行key生成，优化虚拟滚动
        getRowKey(row: any): string {
            return `${row.type}_${row.number}_${row.instrId || 'empty'}`;
        }

        // 缓存的 span-method 实现
        cachedSpanMethodTwo(params: any) {
            const {rowIndex, columnIndex, row} = params;
            if (columnIndex === 0) {
                const rowCount = this.form3.measuringItems.length;
                if (rowIndex == 0) {
                    return {rowspan: rowCount, colspan: 1};
                } else {
                    return {rowspan: 0, colspan: 0};
                }
            }
        }

        // 强制刷新表格（在数据更新后调用）
        forceRender() {
            this.renderKey++;
        }

        // 监听数据变化，更新缓存
        @Watch('form2.measuringDevices', {deep: false})
        onDevicesChange() {
            this.spanMethodTwoCache = null;
        }

        @Watch('form3.measuringItems', {deep: false})
        onItemsChange() {
            this.spanMethodTwoCache = null;
        }

        created() {
            this.init();
        }
        getTitle(){
            let title = "";
            if(this.pageType === "0"){
                if(this.manageStatus === 0){
                    title += "新建";
                }else if(this.manageStatus === 1){
                    title += '复查';
                }else if(this.manageStatus === 2){
                    title += '改造';
                }else if(this.manageStatus === 3){
                    title += '初始';
                }
            }else if(this.pageType === "1"){
                title += "编辑";
            }else if(this.pageType === "2"){
                title += "查看";
            }else{
                title += "审核";
            }
            title += '计量标准'
            return title;
        }
        haveRight(){
            const right = this.$store.state.userRights;
            this.sysMeasuringUpdate = false;
            right.forEach((e: any) => {
                if (e.name == "计量标准审核") {
                    this.sysMeasuringUpdate = true;
                }
            })
        }

        submitReview(){
            const {dataIndex} = this.inspectionParams;
            const dev = this.form2.measuringDevices[dataIndex] as any;
            if(dev){
                const ref = this.$refs['archives'] as any;
                const checkedId = ref.getCheckedId();
                if(!checkedId){
                    this.$message.warning("请选择一条数据后在绑定！");
                    return;
                }
                dev.orderInstrId = checkedId;
            }
            this.closeReviewDialog();
        }
        closeReviewDialog (){
            this.inspectionParams.instrumentsId = 0;
            this.inspectionParams.orderInstrId = 0;
            this.inspectionParams.dataIndex = 0;
            this.reviewInfoDialog.visible = false;
        }
        openReviewInfo(index: number, row: any){
            this.inspectionParams.instrumentsId = row.instrId;
            this.inspectionParams.orderInstrId = row.orderInstrId;
            this.inspectionParams.dataIndex = index;
            this.reviewInfoDialog.visible = true;
        }
        getTempData(e: any) {
            if(e){
                const rData = JSON.parse(e);
                this.form = rData.form;
                this.form2 = rData.form2;
                this.form3 = rData.form3;
                if (rData.fileList) {
                    this.fileList = rData.fileList;
                    const enclosureList = this.fileList.map((e: any) => {
                        return {
                            name: e.name,
                            url: e.url.replace(imageUrl, "")
                        }
                    });
                    this.form.enclosure = JSON.stringify(enclosureList);
                }
                if (rData.fileListV2) {
                    this.fileListV2 = rData.fileListV2;
                    const changeFiles = this.fileListV2.map((e: any) => {
                        return {
                            name: e.name,
                            url: e.url.replace(imageUrl, "")
                        }
                    });
                    this.form.changeFiles = JSON.stringify(changeFiles);
                }
            }

        }

        keyword = "";

        closeFail() {
            setTimeout(() => {
                this.review.failText = "";
            }, 500)
            this.review.failDialog = false;
        }

        passOrNot(status: number) {
            //通过或不通过
            if (status == 3) {
                //不通过，必须有原因
                if (this.review.failText == "") {
                    this.$message.error("请填写不通过原因");
                    return
                }
            }
            this.saveOrUpdate(status, () => {
                authorizeCertApi.updateStatus({
                    ids: this.id,
                    status: status,
                    reason: this.review.failText,
                    type: 1
                }).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("审核成功，1秒后返回上一页！");
                        this.closeFail();
                        setTimeout(() => {
                            this.closePage()
                        }, 1000);
                    }
                })
            }, true);
        }

        filterRules(keyword: string) {
            if (keyword != "") {
                let keyword1 = ""; // 正则匹配出 [A-Z]+
                let key1s = /[A-Za-z]+/i.exec(keyword);
                if (key1s != null && key1s.length > 0) {
                    keyword1 = key1s[0].toUpperCase();
                }

                let keyword2 = ""; //正则匹配出 \d+
                let key2s = /[\d-]+/i.exec(keyword);
                if (key2s != null && key2s.length > 0) {
                    keyword2 = key2s[0];
                }

                let keyword3 = ""; //正则匹配出 常见汉字
                let key3s = /[\u4E00-\u9FFF]+/i.exec(keyword);
                if (key3s != null && key3s.length > 0) {
                    keyword3 = key3s[0];
                }
                rulesApi.list({keyword1: keyword1, keyword2: keyword2, keyword3: keyword3}).then((r) => {
                    if (r.data.result === 0) {
                        this.measuringRulesFilterd = r.data.data;
                    }
                });
            } else {
                this.measuringRulesFilterd = [];
            }
        }

        filterMeasuringItems(keyword: string) {
            this.keyword = keyword;
        }

        cellClass({row, columnIndex}: any) {
            if ((row.type === 1 && row.instrId != undefined) || (row.instrId == undefined && columnIndex === 0)) {
                return {"background-color": "#f5f7fa"}
            }
        }

        init() {
            if(this.$route.path.indexOf('external') !== -1){
                this.fullScreen = true;
            }
            this.headers.Authorization = this.$store.state.Authorization;
            this.id = this.$route.params.id;
            this.pageType = this.$route.params.pageType;
            this.manageStatus = Number(this.$route.params.manageStatus);
            this.mode = Number(this.$route.params.mode);
            this.getUnit();
            this.haveRight();
            const userData = this.$store.state.AuthedUser;
            this.userData = userData;

            if ((this.pageType !== '0') || (this.pageType === '0' && this.id !== '' &&this.id !== '0')) {
                this.loading = true;
                this.getDetail();
            } else {
                const measuringDevices: any = [];
                const measuringItems: any = [];
                measuringItems.push(this.itemAppend(true, 1));
                measuringDevices.push(this.devicesAppend(0, true, 1));
                measuringDevices.push(this.devicesAppend(1, true, 1));

                measuringDevices.sort((a: any, b: any) => a.type - b.type);
                this.form3.measuringItems = measuringItems;
                this.form2.measuringDevices = measuringDevices;
                this.form.companyName = userData.organizationName;
                if (userData.mechanismNames != null && userData.mechanismNames.length > 0) {
                    this.form.companyNameId = userData.mechanismNames[0].id;
                    this.form.ownerId = userData.mechanismNames[0].mechanismId;
                    this.listMyMechanismInstrument();
                }
            }
        }

        handleAvatarSuccess(res: any, file: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.fileList.push({name: "计量标准考核证书.pdf", url: imageUrl + rData})
                this.uploadConfig();
            }
        }

        handleAvatarSuccessV2(res: any, file: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.fileListV2.push({name: file.name, url: imageUrl + rData})
                this.uploadConfig();
            }
        }

        openAddSurveyRangesDiglog(surveyRanges: any, type: string, index: number) {
            // surveyRanges = this.cloneObjectFn(surveyRanges);
          console.log(surveyRanges);
          this.addSurveyRangesEjian.surveyRanges = surveyRanges;
          this.addSurveyRangesEjian.params = {type: type, index: index, param1: 'surveyRangesHtml', param2: 'accuracyLevelHtml'};
          this.addSurveyRangesEjian.visible = true;
        }

      openAddSurveyRangesDiglogEjian(surveyRanges: any) {
        console.log(surveyRanges);
        this.addSurveyRangesEjian.surveyRanges = surveyRanges;
        this.addSurveyRangesEjian.params = {param1: 'surveyRangesHtml', param2: 'accuracyLevelHtml'};
        this.addSurveyRangesEjian.visible = true;
      }
      submitAddSurveyRangesEjian(e: any) {
        console.log(e);
        const {type, index} = this.addSurveyRangesEjian.params;
        let el = null as any;
        if (type === 'items') {
          let item = this.form3.measuringItems[index] as any;
          item = Object.assign({}, item, e);
          this.$set(this.form3.measuringItems, index, item)
          el = this.$refs['form3-surveyRangesHtml-' + index];
        } else {
          this.form = Object.assign({}, this.form, e);
        }
        this.closeAddSurveyRangesDiglogEjian();
        if (el != null) {
          el.$emit('el.form.change')
        }
      }
      closeAddSurveyRangesDiglog() {
        this.addSurveyRanges.visible = false;
        this.addSurveyRanges.surveyRanges = [];
        this.addSurveyRanges.params = null;
      }

      closeAddSurveyRangesDiglogEjian() {
            this.addSurveyRangesEjian.visible = false;
            this.addSurveyRangesEjian.surveyRanges = [];
            this.addSurveyRangesEjian.params = null;
        }

        submitAddSurveyRanges(e: any) {
            const params = e.params;
            let paramList = this.cloneObjectFn(e.paramList);
            const {type, index} = params;
            let el = null as any;
            if (type === 'standard') {
                this.form.paramList = paramList;
            } else if (type === 'devices') {
                let device = this.form2.measuringDevices[index] as any;
                device.paramList = paramList
                el = this.$refs['form2-surveyRanges-' + index];
            } else if (type === 'items') {
                let item = this.form3.measuringItems[index] as any;
                item.paramList = paramList
                el = this.$refs['form3-surveyRanges-' + index];
            }
            this.closeAddSurveyRangesDiglog();
            if (el != null) {
                el.$emit('el.form.change')
            }
        }

        cloneObjectFn(obj: any) {
            return JSON.parse(JSON.stringify(obj));
        }

        //控制上传组件参数
        uploadConfig() {
            if (this.fileList.length == 0) {
                this.accept = ".png,.jpg,.pdf";
                this.limit = 10;
                this.listType = "picture-card"
            } else {
                const fix = this.filesuffix(this.fileList[0].url);
                if (fix == "jpg" || fix == "png") {
                    this.accept = '.png,.jpg';
                } else {
                    this.accept = '.pdf';
                    this.limit = 1;
                    this.listType = "text";
                }
            }
        }

        handleRemoveV2(file: any) {
            const index = this.fileListV2.findIndex((e: any) => e.url === file.url);
            if (index > -1) {
                this.fileListV2.splice(index, 1);
            }
            this.uploadConfig();
        }

        handleRemove(file: any) {
            const index = this.fileList.findIndex((e: any) => e.url === file.url);
            if (index > -1) {
                this.fileList.splice(index, 1);
            }
            this.fileList.map((e: any, index: number) => {
                e.name = "证书影印件" + (index + 1);
            })
            this.uploadConfig();
        }

        handlePictureCardPreview(file: any) {
            const fix = this.filesuffix(file.url);
            if (fix == "pdf") {
                window.open(baseUrl + "/file/download?file=" + file.url.replace(imageUrl, "") + "&name=" + file.name, '_blank');
            } else {
                this.dialogImageUrl = file.url;
                this.imagePreviewVisible = true;
            }
        }

        //上传监控
        beforeAvatarUpload(file: any) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isPDF = file.type === 'application/pdf';

            if (!isJPG && !isPNG && !isPDF) {
                this.$message.error('上传图片只能是 JPG / PNG / PDF格式!');
            }
            return (isJPG || isPNG || isPDF);
        }

        filesuffix(fileName: string) {
            const first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
            const namelength = fileName.length;//取到文件名长度
            const filesuffix = fileName.substring(first + 1, namelength);//截取获得后缀名
            return filesuffix;
        }

        deleteData(index: number, mode: string, delMode: string, type: number) {
            if (mode === 'devices') {
                if (delMode === 'SINGLE') {
                    this.form2.measuringDevices.splice(index, 1);
                } else {
                    const measuringDevices = [] as any;
                    this.form2.measuringDevices.forEach((md: any) => {
                        if (md.type == type && md.number == index) {
                            console.log('')
                        } else {
                            measuringDevices.push(md);
                        }
                    });
                    this.form2.measuringDevices = measuringDevices;
                }
            } else if (mode === 'items') {
                if (delMode === 'SINGLE') {
                    this.form3.measuringItems.splice(index, 1);
                } else {
                    this.form3.measuringItems = this.form3.measuringItems.filter((t: any) => index !== t.number);
                }
            } else if (mode === 'standard') {
                this.form.surveyRanges.splice(index, 1);
            } else if (mode === 'maxError') {
                this.form.maxErrors.splice(index, 1);
            }
        }

        isShowAddBtn(type: number, index: number) {
            const measuringDevices: any = this.form2.measuringDevices;
            const lastIndex = measuringDevices.filter((item: any) => item.type === 0).length;
            if (type === 0) {
                if (index === 0) {
                    return true;
                } else {
                    return false;
                }
            } else if (type === 1) {
                if (lastIndex === index) {
                    return true;
                } else {
                    return false;
                }
            } else if (type === 2) {
                if (index === 0) {
                    return true;
                } else {
                    return false;
                }
            }
            return true;
        }

        delItemRule(ruleList: any, rIndex: number) {
            ruleList.splice(rIndex, 1);
        }
        addItemRule(ruleList: any) {
            ruleList.push({
                ruleId: '',
                ruleName: '',
                ruleNumber: '',
            });
        }
        isDisabled(mode: string){
            const pageType = this.pageType;
            const {status} = this.form;
            const manageStatus = this.manageStatus;
            if(this.mode === 1 && this.sysMeasuringUpdate && this.pageType === "1"){
                return false;
            }
            if(mode === 'block-1') {
                return (['2'].indexOf(pageType) > -1) || (status === 2 && pageType !== '0') || manageStatus === 2;
            }else if(mode === 'block-2') {
                return ['2'].indexOf(pageType) > -1;
            }else if(mode === 'block-3') {
                return (['2'].indexOf(pageType) > -1) || (status === 2 && pageType !== '0') || manageStatus === 2;
            }else if(mode === 'block-1-1') {
                return (['2'].indexOf(pageType) > -1);
            }else if(mode === 'block-1-firstCreatedYear') {
              return (['2'].indexOf(pageType) > -1) || (status === 2 && pageType !== '0' && (!this.firstYearIsNull));
            }else if(mode === 'block-1-code'){
              return (['2'].indexOf(pageType) > -1) || (status === 2 && pageType !== '0' && (!this.codeIsNull));
            }
        }
        hasBtn(mode: string) {
            const pageType = this.pageType;
            const manageStatus = this.manageStatus;
            const {status, isAuditPass} = this.form;
            if(mode === 'past'){
                return pageType === "4";
            }else if(mode === 'add'){
                return pageType === '0' || (pageType === '1' && status !== 2 && isAuditPass === 0)
            }else if(mode === 'tempSave'){
                return pageType === '0' && manageStatus  === 0;
            }else if(mode === 'submit'){
                return ['0', '1'].indexOf(pageType) > -1 && (this.mode === 0)
            }else if(mode === 'audit-save'){
               return (['4'].indexOf(pageType) > -1) || (this.mode === 1 && this.sysMeasuringUpdate)
            }
        }

        addData(type: number, mode: string, number: number) {
            let firstChild = false;
            if (mode === 'devices') {
                const measuringDevices: any = this.form2.measuringDevices;
                if (number === 0) {
                    const numbers = measuringDevices.filter((m: any) => m.type === type).map((test: any) => {
                        return test.number;
                    });
                    number = numbers[numbers.length - 1] + 1;
                    firstChild = true;
                }
                const data = this.devicesAppend(type, firstChild, number);
                measuringDevices.push(data);
                measuringDevices.sort((a: any, b: any) => {
                    let r = a.type - b.type;
                    if (r == 0) {
                        r = a.number - b.number;
                    }
                    return r;
                });
                this.form2.measuringDevices = measuringDevices;
            } else if (mode === 'items') {
                const measuringItems: any = this.form3.measuringItems;
                if (number === 0) {
                    const numbers = measuringItems.map((test: any) => {
                        return test.number;
                    });
                    number = numbers[numbers.length - 1] + 1;
                    firstChild = true;
                }
                const data = this.itemAppend(firstChild, number);
                measuringItems.push(data);
                measuringItems.sort((a: any, b: any) => a.number - b.number);
                this.form3.measuringItems = measuringItems;
            } else if (mode === 'maxError') {
                const maxErrors: any = this.form.maxErrors;
                maxErrors.push({'val': ''});
            }
        }


        itemAppend(firstChild: any, number: number) {
            return {
                id: 0,
                number: number,
                modes: [], //maxError, rule
                firstChild: firstChild,
                projectId: '', //项目ID
                text: '开展的检定/校准项目',
                name: '',
                maxError: '',
                measuringItemRulesList: [{ruleId: '', ruleName: '', ruleNumber: ''}],
                surveyRanges: [] as any,//测量范围
                paramList: [] as Param[],
                measureRange: '',
                accuracyLevel: '',
            };
        }

        devicesAppend(type: number, firstChild: any, number: number) {
            return {
                id: 0,
                number: number,
                firstChild: firstChild,
                type: type,
                text: type === 0 ? '计量标准器' : '主要配套设备',
                instrName: '',
                instrId: '',
                orderInstrId: '',
                model: '',
                paramList: [],
                manufactorName: '',
                factoryNumber: '',
                measureRange: '',
                accuracyLevel: '',
            };
        }
        changeInstrument(row: any){
            let instrumentList = this.form2.instrumentList as any;
            const item = instrumentList.find((item: any) => item.id == row.instrId);
            if(item != null) {
                row.instrName = item.name;
                row.model = item.modelSpecific;
                // let paramList = [];
                // try{
                //     paramList = JSON.parse(item.measureRange)
                // }catch (e) {
                //     console.log(e);
                // }
                // row.paramList = paramList;
                row.measureRange = item.measureRange;
                row.accuracyLevel = item.accuracyLevel;
                row.manufactorName = item.manufactoryName;
                row.factoryNumber = item.serialNumber;
            }
        }
        clearInstrument(row: any){
            row.instrName = '';
            row.instrId = '';
            row.model = '';
            row.paramList = [];
            row.manufactorName = '';
            row.factoryNumber = '';
            row.measureRange = '';
            row.accuracyLevel = '';
        }
        //获取器具详情
        getDetail() {
            measuringStandardApi.getMeasuringStandard({id: this.id}).then(r => {
                if (r.data.result === 0) {
                    const measuringStandard = r.data.data.measuringStandard;
                    this.form = Object.assign(this.form, measuringStandard);
                    this.form.status = measuringStandard.status.value;
                    this.firstYearIsNull = (measuringStandard.firstCreatedYear ? false : true);
                    this.codeIsNull = (measuringStandard.code ? false : true);
                    let paramList: Param[] = r.data.data.paramList;
                    if(this.pageType === '0'){
                      this.form.companyName = this.userData.organizationName;
                    }
                    if(paramList){
                        this.form.paramList = paramList;
                    }
                    this.listMyMechanismInstrument();
                    const devices = this.cloneObjectFn(r.data.data.measuringDevices);
                    const items = this.cloneObjectFn(r.data.data.measuringItems);
                    const measuringDevices = [] as any;
                    const measuringItems = [] as any;
                    if (this.form.enclosure) {
                        this.fileList = [];
                        try {
                            const obj = JSON.parse(this.form.enclosure);
                            if (typeof obj == 'object' && obj) {
                                for (let i = 0; i < obj.length; i++) {
                                    this.fileList.push({name: obj[i].name, url: imageUrl + obj[i].url})
                                }
                            }
                        } catch (e) {
                            const arr = this.form.enclosure.split(",");
                            for (let i = 0; i < arr.length; i++) {
                                this.fileList.push({name: "证书文件", url: imageUrl + arr[i]})
                            }
                        }
                    }
                    if (this.form.changeFiles) {
                        this.fileListV2 = [];
                        try {
                            const obj = JSON.parse(this.form.changeFiles);
                            if (typeof obj == 'object' && obj) {
                                for (let i = 0; i < obj.length; i++) {
                                    this.fileListV2.push({name: obj[i].name, url: imageUrl + obj[i].url})
                                }
                            }
                        } catch (e) {
                            const arr = this.form.changeFiles.split(",");
                            for (let i = 0; i < arr.length; i++) {
                                this.fileListV2.push({name: "证书文件", url: imageUrl + arr[i]})
                            }
                        }
                    }
                    this.uploadConfig();
                    let num = 0;
                  console.log(devices);
                  devices.forEach((device: any) => {
                        // const paramList = JSON.parse(device.surveyRangesJson);
                        num++;
                        measuringDevices.push({
                            text: device.type === 0 ? '计量标准器' : '主要配套设备',
                            number: num,
                            firstChild: true,
                            ...device,
                          measureRange: device.surveyRangesJson,
                          accuracyLevel: device.accuracyLevel,
                            // paramList: paramList,
                        });
                    });
                    num = 0;
                    items.forEach((item: any) => {
                        const paramList = JSON.parse(item.surveyRangesJson);
                        num++;
                        measuringItems.push({
                            text: '开展的检定/校准项目',
                            number: num,
                            firstChild: true,
                            ...item,
                            paramList: paramList,

                        });
                    });
                    const count1 = measuringDevices.filter((m: any) => m.type == 0).length; //计量标准器
                    const count2 = measuringDevices.filter((m: any) => m.type == 1).length; //主要配套设备
                    const count3 = measuringItems.length; //开展的检定/校准项目
                    if (count1 == 0) {
                        measuringDevices.push(this.devicesAppend(0, true, 1))
                    }
                    if (count2 == 0) {
                        this.form2.isDevicesNone = true;
                        measuringDevices.push(this.devicesAppend(1, true, 1));
                    }
                    if (count3 == 0) {
                        measuringItems.push(this.itemAppend(true, 1));
                    }
                    measuringDevices.sort((a: any, b: any) => {
                        let r = a.type - b.type;
                        if (r == 0) {
                            r = a.number - b.number;
                        }
                        return r;
                    });
                    this.form.useStatus = measuringStandard.useStatus.value;
                    this.form3.measuringItems = measuringItems;
                    this.form2.measuringDevices = measuringDevices;
                    this.loading = false;
                }
            })
        }

        saveOrUpdate(submitType: number, callback: any, force: boolean) {
            const enclosureList = this.fileList.map((e: any) => {
                return {
                    name: e.name,
                    url: e.url.replace(imageUrl, "")
                }
            })
            const changeFiles = this.fileListV2.map((e: any) => {
                return {
                    name: e.name,
                    url: e.url.replace(imageUrl, "")
                }
            });
            this.form.changeFiles = changeFiles.length == 0 ? "" : JSON.stringify(changeFiles);
            this.form.enclosure = enclosureList.length == 0 ? "" : JSON.stringify(enclosureList);
            this.formVerification(submitType, () => {
                const loading = this.$loading({
                    text: '正在保存',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if (this.form.status == 2 && this.sysMeasuringUpdate && this.mode === 1) {
                    submitType = 2;
                }
                const url = this.pageType === '0' ? this.save(submitType, force) : this.update(submitType, force);
                url.then(res => {
                    loading.close();
                    if(res.data.result === 2){
                        this.$confirm('该标准与您单位现有标准名称相似，请核实，如果是相同标准，请返回选择复查添加', '提示', {
                            confirmButtonText: '继续添加',
                            cancelButtonText: '返回',
                            type: 'warning'
                        }).then(() => {
                            this.saveOrUpdate(submitType, callback, true);
                        }).catch(() => {
                            this.closePage();
                        });
                        return;
                    }else if(res.data.result === 3){
                      this.$confirm('该标准与您单位现有标准重复，请返回选择复查添加', '提示', {
                        confirmButtonText: '返回',
                        type: 'warning'
                      }).then(() => {
                        this.closePage();
                      })
                      return;
                    }
                    if (res.data.result !== 0) {
                        //报错信息
                        return;
                    }
                    let $tempSave = this.$refs.tempSave as HTMLFormElement;
                    if ($tempSave) {
                        $tempSave.deleteUserConfig();
                    }
                    if (callback) {
                        callback();
                    } else {
                        this.$message.success("保存成功，1秒后返回上一页！");
                        setTimeout(() => {
                            this.closePage()
                        }, 1000);
                    }
                });
            });
        }

        formVerification(submitType: number, callback: any) {
            //不通过  不做校验
            if (submitType == 3) {
                callback();
                return;
            }
            let form = this.$refs.form as HTMLFormElement;
            let form2 = this.$refs.form2 as HTMLFormElement;
            let form3 = this.$refs.form3 as HTMLFormElement;
            form.validate((valid: any) => {
                if (valid) {
                    form2.validate((valid: any) => {
                        if (valid) {
                            form3.validate((valid: any) => {
                                if (valid) {
                                    callback();
                                }else {
                                    this.$message.warning("未填写完整信息");
                                }
                            })
                        }else {
                            this.$message.warning("未填写完整信息");
                        }
                    });
                }else {
                    this.$message.warning("未填写完整信息");
                }
            });
        }
        //整理计量标准器测量范围
        packageDevicesSurveyRanges(measuringDevices: any){
            let devices = measuringDevices.filter((item: any) => item.firstChild);
            if(this.form2.isDevicesNone){
                devices = devices.filter((d: any) => d.type == 0);
            }
            devices.forEach((device: any) => {
                device.paramList?.forEach((param: Param) => {
                    param.paramType = 1;
                });
            });
            return devices;
        }
        //整理授权项目测量范围
        packageItemsSurveyRanges(measuringItems: any){
            //整理 授权项目
            const items = measuringItems.filter((item: any) => item.firstChild);
            items.forEach((item: any) => {
                item.paramList.forEach((param: Param) => {
                    param.paramType = 2;
                });
            });
            return items;
        }

        //打包数据
        packageResult() {
            const measuringDevices = this.form2.measuringDevices;
            const measuringItems = this.form3.measuringItems;
            const form = this.cloneObjectFn(this.form);
            if(this.pageType === '0' && [1,2, 4, 5].indexOf(this.manageStatus) > -1){
              form.replaceId = this.id;
              form.agingStatus = 1;
            }
            const devices = this.packageDevicesSurveyRanges(measuringDevices);
            const items = this.packageItemsSurveyRanges(measuringItems);
            form.surveyRanges = JSON.stringify(form.paramList);
            return {
                measuringStandard: form,
                measuringItems: items,
                measuringDevices: devices,
                paramList: form.paramList,
            } as any
        }

        objectSpanMethodTwo({rowIndex, columnIndex, row}: any) {
            if (columnIndex === 0) {
                const rowCount = this.form3.measuringItems.length;
                if (rowIndex == 0) {
                    return {
                        rowspan: rowCount,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        }

        objectSpanMethodOne({rowIndex, columnIndex, row}: any) {
            if (columnIndex === 0) {
                const rowCount = this.form2.measuringDevices.filter((item: any) => item.type === 0).length;
                if (rowIndex == 0) {
                    return {
                        rowspan: rowCount,
                        colspan: 1
                    };
                } else if (rowIndex === rowCount) {
                    return {
                        rowspan: this.form2.measuringDevices.length - rowCount,
                        colspan: 1
                    };
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
        }

        getUnit() {
            dictApi.listDictInstrument().then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.porjectTree(rData);
                    // 使用 Object.freeze 冻结项目列表，减少响应式追踪开销
                    this.projectList = Object.freeze(rData);
                }
            })
        }

        getProjectData(projectId: number, projectList: any) {
            let result = null as any;
            for (let i = 0; i < projectList.length; i++) {
                const project = projectList[i];
                if (project.children != null) {
                    const r = this.getProjectData(projectId, project.children);
                    if (r != null) {
                        result = r;
                    }
                } else {
                    if (project.instrumentNameId === projectId) {
                        result = project;
                    }
                }
            }
            return result;
        }

        porjectTree(projectList: any) {
            projectList.forEach((project: any) => {
                if (project.children.length > 0) {
                    this.porjectTree(project.children);
                } else {
                    project.children = null;
                }
            })
        }

        calcManageStatus(){
            if(this.manageStatus === 0 || this.manageStatus === 3){
                const date = new Date(this.form.firstCreatedYear);
                if(date.getFullYear() < new Date().getFullYear()){
                    return 3;
                }else{
                    return 0;
                }
            }
            return this.manageStatus;
        }
        save(submitType: number, force: boolean) {
            const result = this.packageResult();
            result.measuringStandard.manageStatus = this.calcManageStatus();
            result.measuringStandard.isAuditPass = 0;
            result.measuringStandard.shareStatus = 0;
            result.submitType = submitType;
            result.force = force;
            return measuringStandardApi.save(result);
        }

        update(submitType: number, force: boolean) {
            const result = this.packageResult();
            result.submitType = submitType;
            result.force = force;
            return measuringStandardApi.update(result)
        }

        changeProject(row: any) {
            this.showAllLevels = false;
            const projectList = this.projectList;
            const project = this.getProjectData(row.projectId, projectList);
            if (project.name) {
                row.name = project.name;
            }
        }

        changeMeasuringRule(row: any) {
            const project: any = this.measuringRulesFilterd.find((p: any) => p.id === row.ruleId);
            if (project != null) {
                row.ruleName = project.name;
                row.ruleNumber = project.number;
            }
        }

        //改变发证机关
        changeManufactory2(e: any) {
            this.form.issuingAuthorityNameId = e.mechanismNameId;
            this.form.issuingAuthority = e.mechanismName;
        }

        //改变建标单位
        changeCompany(e: any) {
            this.form.companyName = e.mechanismName;
            this.form.companyNameId = e.mechanismNameId;
            this.form.ownerId = e.mechanismId;
            this.listMyMechanismInstrument();
        }

        clearForm() {
            const options = this.$options as any;
            Object.assign(this.$data, options.data.call(this));
            this.init();
        }

        listMyMechanismInstrument(){
          // instrumentApi.listMyMechanismInstrument({ownerId: this.form.ownerId}).then((r: any) => {
          //     if(r.data.result === 0){
          //         this.form2.instrumentList = r.data.data;
          //         this.form2.instrumentListFilter = r.data.data;
          //     }
          // });
          newInstrumentApi.listMyMechanismInstrument(this.form.ownerId).then((r: any) => {
            if(r.data.result === 0){
              this.form2.instrumentList = r.data.data;
              this.form2.instrumentListFilter = r.data.data;
            }
          });
        }
        onUpdateInstr(instrId: number, index: number){
            this.updateInstr.instrId = instrId;
            this.updateInstr.dataIndex = index;
            this.updateInstr.visible = true;
        }
        closeUpdateInstr(){
            this.updateInstr = {instrId: -1, dataIndex: -1, visible: false};
        }
        submitUpdateInstr(e: any){
            const {dataIndex} = this.updateInstr;
            const {instrId, instrName, model, paramList,measureRange,accuracyLevel, factoryNumber, manufactoryName} = e;
            const measuringDevices = this.form2.measuringDevices[dataIndex] as any;
            measuringDevices.instrId = instrId;
            measuringDevices.instrName = instrName;
            measuringDevices.model = model;
          // measuringDevices.paramList = paramList;
            measuringDevices.measureRange = measureRange;
            measuringDevices.accuracyLevel = accuracyLevel;
            measuringDevices.factoryNumber = factoryNumber;
            measuringDevices.manufactorName = manufactoryName
            this.listMyMechanismInstrument();
            this.closeUpdateInstr();
        }
    }
